module.controller('sampleAnalysisResultCtrl', [ '$timeout', '$document', '$scope', '$rootScope', '$state', 'planSamplingService', 'alertService', 'ASEBIOL_CONSTANTS', sampleAnalysisResultCtrlFn ]);

function sampleAnalysisResultCtrlFn($timeout, $document, $scope, $rootScope, $state, planSamplingService, alertService, ASEBIOL_CONSTANTS) {
	var vm = this;

	vm.loading = false;
	var vmparent = $scope.$parent.ctrl;
	$scope.CNT = ASEBIOL_CONSTANTS;
	
	var idPlanSampling = $scope.ctrl.idPlanSampling;
	var idSampling = $scope.ctrl.idSampling;
	var idSample = $scope.ctrl.idSample;
	var duration = 1000; // milliseconds
	var offset = 40;

	var vmparent = $scope.$parent.ctrl;
	
	vm.validation = {
		observations : {
			maxlength : 500
		}
	};

	vm.analyzeInfo = {
			
	detectable: false,
			
	};
	
	vm.isCollapse = true;

	var result = {		
		result : null,
		dilution : null,
		presentLack : true,
		observations : null,	
		
	}

	function init() {
		if (!angular.isUndefined($scope.ctrl.sample)) {
			$scope.ctrl.sample.sampleAnalysisResult.forEach(function(a) {
				a.resultValues = cloneObject(result);
				a.isCollapse = false;
			//	a.resultValues.observations = vmparent.sample.sampleAnalysisResult["0"].observationsResult;
		    //	a.resultValues.dilution =  vmparent.sample.sampleAnalysisResult["0"].dilutionResult;
			//	a.resultValues.result =  vmparent.sample.sampleAnalysisResult["0"].result;
			});		
		}
		
		$timeout(scrollToSamplingAnalysis, 100);
	}
	
	/*
	 * cargar datos del analisis al seleccionar editar
	 */

	vm.onEdit = function(sar) {
		
		var result = {};
		
		if(sar.detectable == false){
		result.detectable = true;}
		
		result.observations = sar.observationsResult;		              
		result.dilution = sar.dilutionResult;
		result.result = sar.result;	
					
		result.samplingMethod = [ {
			id : sar.samplingMethod.id,
			name : sar.samplingMethod.name,
			uncertainty : sar.samplingMethod.uncertainty
		} ]
		
		sar.resultValues = result;
	
	}

	vm.submitForm = function(sar) {
 		
		if(sar.analized == false){
			alertService.showSwtQuestion('Analizar la muestra con la técnica de ' + sar.technique.name, function() {	
				analyzeSample(sar);
			});
		}
		if(sar.analized == true)			
			alertService.showSwtQuestion('Actualizar análisis ' , function() {	
				updateAnalyzeSample(sar);							
			});
	}

	init(); 

	function analyzeSample(sar) {
		vm.loading = true;

		var analysisModel = {
				observationsResult : sar.resultValues.observations,
				dilutionResult : sar.resultValues.dilution,
				detectable: true,
				updateAnalysis: false,
				idSamplingMethod : sar.resultValues.samplingMethod[0].id
		};
		
		if(sar.resultValues.detectable==undefined){
			sar.resultValues.detectable=false;
		}
			

		if(sar.resultValues.detectable){
			analysisModel.detectable = !sar.resultValues.detectable;
		}else {			
			if (sar.technique.resulttype == 'RANGE' || sar.technique.resulttype == 'UPPER_LIMIT' || sar.technique.resulttype == 'LOWER_LIMIT')			
				analysisModel.result = sar.resultValues.result;	
			
			if (sar.technique.resulttype == 'PRESENT_LACK')
				analysisModel.result = sar.resultValues.presentLack ? 1 : 0;
		}
		
		planSamplingService.analyzeSample(idPlanSampling, idSampling, idSample, sar.id, analysisModel).then(function(response) {
			alertService.showSuccess("Muestra analizada correctamente");
			if ($scope.refreshSample)
				$scope.refreshSample(idPlanSampling, idSampling, idSample);
			$scope.ctrl.reloadData();
			vm.loading = false;
		}, function(response) {
			vm.loading = false;
		});
	}

	function updateAnalyzeSample(sar) {
		vm.loading = true;

		var updateAnalysisModel = {
				observationsResult : sar.resultValues.observations,
				dilutionResult : sar.resultValues.dilution,
				detectable: true,
				updateAnalysis: true,
				idSamplingMethod : sar.resultValues.samplingMethod[0].id
		};
		if (sar.technique.resulttype == 'RANGE' || sar.technique.resulttype == 'UPPER_LIMIT' || sar.technique.resulttype == 'LOWER_LIMIT')
			updateAnalysisModel.result = sar.resultValues.result;
		if (sar.technique.resulttype == 'PRESENT_LACK')
			updateAnalysisModel.result = sar.resultValues.presentLack ? 1 : 0;

		if(sar.resultValues.detectable){
			updateAnalysisModel.detectable = !sar.resultValues.detectable;
		}

		planSamplingService.updateAnalyzeSample(idPlanSampling, idSampling, idSample, sar.id, updateAnalysisModel).then(function(response) {
			alertService.showSuccess("Muestra Actualizada correctamente");
			if ($scope.refreshSample)
				$scope.refreshSample(idPlanSampling, idSampling, idSample);
			$scope.ctrl.reloadData();
			vm.loading = false;
		}, function(response) {
			vm.loading = false;
		});
	}

	function scrollToSamplingAnalysis() {
		if(angular.isUndefined($scope.ctrl.sample))
			return;
		if($scope.ctrl.sample.state != SAMPLE_STATE.ADMITED.enumName && $scope.ctrl.sample.state != SAMPLE_STATE.ANALYZING.enumName)
			return;
		var samplingAnalysis = {};
		samplingAnalysis = angular.element(document.getElementById('samplingAnalysis'));
		$document.scrollToElement(samplingAnalysis, offset, duration);
	}

	init();
}
